export default "__VITE_ASSET__DHjNM_N2__"